interface DangerCircleProps {
  color?: string;
}

function DangerCircle({ color = "#FF0000", ...props }: DangerCircleProps) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" />
      <path
        d="M11.0837 7.41602H13.0792V14.0714H11.0837V7.41602ZM11.0837 15.1762H13.0792V17.3933H11.0837V15.1762Z"
        fill={color}
      />
    </svg>
  );
}

export default DangerCircle;
